export const getComplexTime=(complexTime)=>{
  if(complexTime)
    return complexTime;
  else
    return {
      open:'08:00',
      close:'24:00'
    }

};